import React from 'react';
import { Button } from '@carnica/ui-kit';
import { Metric } from "../../metric";
import { HeaderThemeView } from "../../store/slices/layout";
export var AdditionalLinks = function AdditionalLinks(_ref) {
  var additionalLinks = _ref.additionalLinks,
    headerTheme = _ref.headerTheme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, additionalLinks.map(function (_ref2) {
    var title = _ref2.title,
      href = _ref2.href;
    return /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: title,
      events: {
        headerMetric: ['handleTopButtonClick']
      },
      key: title,
      mode: "click",
      "data-t-id": "components-AdditionalLinks"
    }, /*#__PURE__*/React.createElement(Button, {
      href: href,
      size: "m",
      tagName: "a",
      view: HeaderThemeView[headerTheme],
      "data-t-id": "components-AdditionalLinks"
    }, title));
  }));
};